// import React from 'react';
//
// /**
//  * An array defining the questions and their corresponding keys in the API data.
//  * This makes the component easy to update if questions change.
//  */
// const peerFeedbackQuestions = [
//     {
//         key: 'can_express_emotions',
//         text: "My friend can talk about how he/she feels, e.g., happy, confident, upset, or angry."
//     },
//     {key: 'can_calm_down', text: 'My friend can calm himself/herself down during difficult situations.'},
//     {key: 'can_understand_others', text: "My friend can understand how his/her friends feel."},
//     {key: 'respects_opinions', text: "My friend respects everyone's opinions."},
//     {key: 'helps_after_fight', text: 'My friend can help others make up after a fight.'},
//     {key: 'comforts_when_sad', text: 'When someone is sad, my friend can make them feel better.'},
// ];
//
// /**
//  * A reusable component to display the four emoji response options.
//  * It dynamically highlights the selected response.
//  *
//  * @param {object} props - The component props.
//  * @param {string} props.selection - The peer's answer ('Yes', 'Sometimes', 'No', 'Not sure').
//  */
// const PeerEmojiResponse = ({selection}) => {
//     // Defines the emoji and color for each response type
//     const responses = [
//         {value: 'Yes', emoji: '😊👍', color: 'green'},
//         {value: 'Sometimes', emoji: '😐👈', color: 'yellow'},
//         {value: 'No', emoji: '😔👎', color: 'red'},
//         {value: 'Not sure', emoji: '🤔❓', color: 'gray'}
//     ];
//
//     return (
//         <div className="flex justify-around items-center w-full text-3xl mt-2">
//             {responses.map(res => (
//                 <div
//                     key={res.value}
//                     // The selected emoji gets a ring around it for emphasis
//                     className={`p-1 rounded-full transform transition-transform ${selection === res.value ? 'ring-2 ring-offset-2 ring-blue-500 scale-110' : ''}`}
//                 >
//                     {res.emoji}
//                 </div>
//             ))}
//         </div>
//     );
// };
//
// /**
//  * Renders the redesigned Peer Feedback page for the Preparatory Stage HPC Report,
//  * matching the provided reference image and A4 dimensions.
//  *
//  * @param {object} props - The component props.
//  * @param {object} props.assignment - The assignment data object from the API.
//  * @param {number} props.pageNumber - The page number to display.
//  */
// const PeerFeedbackPage = ({assignment, pageNumber}) => {
//     // Render a placeholder if the peer_assessment data is missing.
//     if (!assignment || !assignment.peer_assessment) {
//         return (
//             <div className="report-page bg-white flex items-center justify-center font-[Arial]">
//                 <p>Peer Feedback data not available for this assignment.</p>
//             </div>
//         );
//     }
//
//     const {peer_assessment} = assignment;
//
//     return (
//         <div className="report-page bg-white font-[Arial]" style={{padding: '15mm'}}>
//             {/* Header Section */}
//             <header className="flex justify-between items-center mb-4">
//                 <h1 className="text-3xl font-bold text-orange-600">Peer Feedback</h1>
//                 <div className="bg-orange-500 text-white text-lg font-bold py-2 px-8 rounded-full shadow-lg">
//                     Peer 1
//                 </div>
//             </header>
//
//             <p className="text-lg mb-6 text-gray-700">
//                 Circle the most appropriate option for each sentence.
//             </p>
//
//             {/* Name Fields Section */}
//             <div className="grid grid-cols-2 gap-6 mb-8">
//                 <div className="bg-purple-100 border-2 border-purple-300 rounded-lg p-2 shadow-sm relative pb-4">
//                     <p className="font-bold text-gray-800">My name:</p>
//                     <div className="bg-white mt-1 p-2 rounded min-h-[2.5rem] font-semibold text-gray-900">
//                         {peer_assessment.name || ''}
//                     </div>
//                     <svg className="absolute bottom-0 left-0 w-full h-2 text-purple-400" viewBox="0 0 100 4"
//                          preserveAspectRatio="none">
//                         <path d="M0,2 Q25,0 50,2 T100,2" stroke="currentColor" strokeWidth="2" fill="none"/>
//                     </svg>
//                 </div>
//                 <div className="bg-green-100 border-2 border-green-300 rounded-lg p-2 shadow-sm relative pb-4">
//                     <p className="font-bold text-gray-800">My friend's name:</p>
//                     <div className="bg-white mt-1 p-2 rounded min-h-[2.5rem] font-semibold text-gray-900">
//                         {peer_assessment.friend_name || ''}
//                     </div>
//                     <svg className="absolute bottom-0 left-0 w-full h-2 text-green-500" viewBox="0 0 100 4"
//                          preserveAspectRatio="none">
//                         <path d="M0,2 Q25,4 50,2 T100,2" stroke="currentColor" strokeWidth="2" fill="none"/>
//                     </svg>
//                 </div>
//             </div>
//
//             {/* Feedback Questions Table */}
//             <table className="w-full border-collapse">
//                 <tbody>
//                 {peerFeedbackQuestions.map(({key, text}, index) => (
//                     <tr
//                         key={key}
//                         // Alternating row colors as per the design
//                         className={`border-b-8 ${index % 2 === 0 ? 'bg-orange-50' : 'bg-yellow-50'} border-white`}
//                     >
//                         <td className="w-1/2 p-4 text-md font-semibold align-middle">
//                             {index + 1}. {text}
//                         </td>
//                         <td className="w-1/2 p-3">
//                             <PeerEmojiResponse selection={peer_assessment[key]}/>
//                             <div className="grid grid-cols-4 gap-2 text-center text-sm font-bold mt-2">
//                                 <div
//                                     className={`py-1 rounded-md ${peer_assessment[key] === 'Yes' ? 'text-green-700' : 'text-gray-500'}`}>Yes
//                                 </div>
//                                 <div
//                                     className={`py-1 rounded-md ${peer_assessment[key] === 'Sometimes' ? 'text-yellow-700' : 'text-gray-500'}`}>Sometimes
//                                 </div>
//                                 <div
//                                     className={`py-1 rounded-md ${peer_assessment[key] === 'No' ? 'text-red-700' : 'text-gray-500'}`}>No
//                                 </div>
//                                 <div
//                                     className={`py-1 rounded-md ${peer_assessment[key] === 'Not sure' ? 'text-gray-700' : 'text-gray-500'}`}>Not
//                                     sure
//                                 </div>
//                             </div>
//                         </td>
//                     </tr>
//                 ))}
//                 </tbody>
//             </table>
//
//             {/* Page Number */}
//             {pageNumber && (
//                 <div className="absolute bottom-4 left-0 right-0 text-center text-sm font-medium">
//                     {pageNumber}
//                 </div>
//             )}
//         </div>
//     );
// };
//
// export default PeerFeedbackPage;

import React from 'react';

// Import the new SVG icons for peer feedback
import YesIcon from '../../../../Assets/Prepratory/picsvg_download (17).svg';
import SometimesIcon from '../../../../Assets/Prepratory/picsvg_download (18).svg';
import NoIcon from '../../../../Assets/Prepratory/picsvg_download (19).svg';
import NotSureIcon from '../../../../Assets/Prepratory/picsvg_download (20).svg';


/**
 * An array defining the questions and their corresponding keys in the API data.
 */
const peerFeedbackQuestions = [
    "My friend can talk about how he/she feels, e.g., happy, confident, upset, or angry.",
    "My friend can calm himself/herself down during difficult situations.",
    "My friend can understand how his/her friends feel.",
    "My friend respects everyone's opinions.",
    "My friend can help others make up after a fight.",
    "When someone is sad, my friend can make them feel better."
];

const responseIcons = [
    { img: YesIcon, alt: "Yes", color: "#5DB141" },
    { img: SometimesIcon, alt: "Sometimes", color: "#F7B42C" },
    { img: NoIcon, alt: "No", color: "#F2555B" },
    { img: NotSureIcon, alt: "Not sure", color: "#C9A145" },
];

// Order must match your questions order
const responseKeys = [
    "can_express_emotions",   // Q1 - fallback to old structure
    "can_calm_down",          // Q2 - fallback to old structure  
    "can_understand_others",  // Q3 - fallback to old structure
    "respects_opinions",      // Q4 - fallback to old structure
    "helps_after_fight",      // Q5 - fallback to old structure
    "comforts_when_sad"       // Q6 - fallback to old structure
];

// Mapping for the actual data structure we're receiving
const actualDataMapping = {
    "can_express_emotions": "friend_easy",
    "can_calm_down": "friend_liked",
    "can_understand_others": "friend_needed",
    "respects_opinions": "friend_easy", // fallback
    "helps_after_fight": "friend_liked", // fallback
    "comforts_when_sad": "friend_needed" // fallback
};


/**
 * A reusable component to display the four emoji response options, matching the reference design.
 *
 * @param {object} props - The component props.
 * @param {string} props.selection - The peer's answer ('Yes', 'Sometimes', 'No', 'Not sure').
 */
// const PeerEmojiResponse = ({selection}) => {
//     // Defines the new SVG icons and colors for each response type
//     const responses = [
//         {value: 'Yes', icon: YesIcon, color: 'bg-[#e36c09]'},
//         {value: 'Sometimes', icon: SometimesIcon, color: 'bg-[#e36c09]'},
//         {value: 'No', icon: NoIcon, color: 'bg-[#e36c09]'},
//         {value: 'Not sure', icon: NotSureIcon, color: 'bg-[#e36c09]'}
//     ];
//
//     return (
//         <div className="w-full">
//             <div className="flex justify-around items-center w-full">
//                 {responses.map(res => (
//                     <div key={res.value} className="flex flex-col items-center">
//                         {/* The selected emoji gets a blue circle around it */}
//                         <div
//                             className={`p-1 rounded-full ${selection === res.value ? 'border-2 border-blue-500' : 'border-2 border-transparent'}`}>
//                             <img src={res.icon} alt={res.value} className="w-12 h-12"/>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//             <div className="grid grid-cols-4 gap-2 text-center text-xs font-bold text-white mt-2">
//                 {responses.map(res => (
//                     <div key={res.value} className={`p-1 rounded-md ${res.color}`}>
//                         {res.value}
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

/**
 * Renders the redesigned Peer Feedback page for the Preparatory Stage HPC Report.
 *
 * @param {object} props - The component props.
 * @param {object} props.assignment - The assignment data object from the API.
 * @param {number} props.pageNumber - The page number to display.
 */
const PeerFeedbackPage = ({ assignment }) => {
    // Debug: Log the assignment data
    console.log("PeerFeedbackPage - assignment:", assignment);
    console.log("PeerFeedbackPage - peer_assessment:", assignment?.peer_assessment);

    // Render a placeholder if the peer_assessment data is missing.
    if (!assignment || !assignment.peer_assessment) {
        return (
            <div className="report-page bg-white flex items-center justify-center font-[poppins]"
                style={{ width: '210mm', height: '297mm' }}>
                <p>Peer Feedback data not available for this assignment.</p>
            </div>
        );
    }

    const { peer_assessment } = assignment;
    // console.log(peer_assessment);

    return (
        <div className="report-page bg-white font-[poppins]" style={{
            width: '210mm',
            height: '297mm',
            padding: '15mm 20mm',
            margin: '0 auto',
            fontSize: '10pt',
            lineHeight: '1.5',
            color: '#333333',
            boxSizing: 'border-box',
            overflow: 'hidden'
        }}>
            {/* Header Section - Centered title */}
            <header className="relative text-center mb-4">
                <h1 className="text-2xl font-bold text-orange-600">Peer Feedback</h1>
                {/* Custom SVG for the "Peer 1" tag to match the hand-drawn, more rounded style */}
                <div className="absolute top-0 right-0">
                    <div className="relative">
                        <svg width="120" height="50" viewBox="0 0 120 50">
                            <path
                                d="M25 5 C10 5 5 15 5 25 C5 35 10 45 25 45 H95 C110 45 115 35 115 25 C115 15 110 5 95 5 Z"
                                fill="#F97316" />
                        </svg>
                        <div className="absolute inset-0 flex items-center justify-center text-white text-lg font-bold">
                            Peer 1
                        </div>
                    </div>
                </div>
            </header>

            <p className="text-md mb-6 text-gray-700">
                Circle the most appropriate option for each sentence.
            </p>

            {/* Name Fields Section */}
            <div className="grid grid-cols-2 gap-6 mb-8">
                <div className={`border-2 rounded-lg p-2 shadow-sm relative pb-4 transition-all duration-200 ${peer_assessment.name && peer_assessment.name !== '[Student Name]'
                        ? 'bg-purple-200 border-purple-400 shadow-md'
                        : 'bg-purple-100 border-purple-300'
                    }`}>
                    <p className="font-bold text-gray-800">My name:</p>
                    <div className={`bg-white mt-1 p-2 rounded min-h-[2.5rem] ${peer_assessment.name && peer_assessment.name !== '[Student Name]'
                            ? 'font-bold text-purple-900 border border-purple-300'
                            : 'font-semibold text-gray-900'
                        }`}>
                        {peer_assessment.name || '[Student Name]'}
                    </div>
                    <svg className="absolute bottom-0 left-0 w-full h-2 text-purple-400" viewBox="0 0 100 4"
                        preserveAspectRatio="none">
                        <path d="M0,2 Q25,0 50,2 T100,2" stroke="currentColor" strokeWidth="2" fill="none" />
                    </svg>
                </div>
                <div className={`border-2 rounded-lg p-2 shadow-sm relative pb-4 transition-all duration-200 ${peer_assessment.friend_name && peer_assessment.friend_name !== '[Friend Name]'
                        ? 'bg-green-200 border-green-400 shadow-md'
                        : 'bg-green-100 border-green-300'
                    }`}>
                    <p className="font-bold text-gray-800">My friend's name:</p>
                    <div className={`bg-white mt-1 p-2 rounded min-h-[2.5rem] ${peer_assessment.friend_name && peer_assessment.friend_name !== '[Friend Name]'
                            ? 'font-bold text-green-900 border border-green-300'
                            : 'font-semibold text-gray-900'
                        }`}>
                        {peer_assessment.friend_name || '[Friend Name]'}
                    </div>
                    <svg className="absolute bottom-0 left-0 w-full h-2 text-green-500" viewBox="0 0 100 4"
                        preserveAspectRatio="none">
                        <path d="M0,2 Q25,4 50,2 T100,2" stroke="currentColor" strokeWidth="2" fill="none" />
                    </svg>
                </div>
            </div>
            {/* Feedback Questions Table */}
            <table className="w-full border border-[#e36c09] border-collapse bg-white">

                <tbody>
                    {peerFeedbackQuestions.map((text, i) => {
                        const responseKey = responseKeys[i];
                        // Try the original key first, then the mapped key
                        let selectedValue = peer_assessment[responseKey];
                        if (selectedValue === undefined && actualDataMapping[responseKey]) {
                            selectedValue = peer_assessment[actualDataMapping[responseKey]];
                        }

                        return (
                            <tr key={i} className="border-b border-[#e36c09]">
                                {/* Left: Statement */}
                                <td className="bg-[#fde9d9] align-top px-3 py-2 w-[46%] border-r border-[#E87C21]">
                                    <span className="text-[16px] font-normal">{i + 1}. {text}</span>
                                </td>
                                {/* Right: Emojis + Option Labels */}
                                <td className="align-top w-[54%] p-0">
                                    {/* Emojis Row */}
                                    <div className="flex flex-row w-full justify-between items-center pt-1 pb-1 px-1">
                                        {responseIcons.map(({ img, alt }, idx) => (
                                            <div
                                                key={alt}
                                                className={`mx-1 p-1 rounded-full transition-all duration-150
                                                ${selectedValue === alt
                                                        ? "border-3 border-orange-500 shadow-lg bg-orange-50 scale-110"
                                                        : "border-2 border-transparent hover:border-gray-300"}
                                            `}
                                                style={{
                                                    width: 70, height: 70,
                                                    display: "inline-flex", alignItems: "center", justifyContent: "center"
                                                }}
                                            >
                                                <img src={img} alt={alt} style={{ width: 56, height: 56 }} className="block" />
                                            </div>
                                        ))}
                                    </div>
                                    {/* Option labels row with prominence for selected */}
                                    <div className="flex flex-row w-full">
                                        <div className={`flex-1 text-center py-[11px] text-[14px] transition-all duration-150 ${selectedValue === 'Yes'
                                                ? 'text-white font-bold shadow-inner'
                                                : 'text-white'
                                            }`} style={{
                                                background: selectedValue === 'Yes' ? '#D97706' : '#E87C21',
                                                borderRight: "1px solid #fff"
                                            }}>Yes
                                        </div>
                                        <div className={`flex-1 text-center py-[11px] text-[14px] transition-all duration-150 ${selectedValue === 'Sometimes'
                                                ? 'text-white font-bold shadow-inner'
                                                : 'text-white'
                                            }`} style={{
                                                background: selectedValue === 'Sometimes' ? '#D97706' : '#E87C21',
                                                borderRight: "1px solid #fff"
                                            }}>Sometimes
                                        </div>
                                        <div className={`flex-1 text-center py-[11px] text-[14px] transition-all duration-150 ${selectedValue === 'No'
                                                ? 'text-white font-bold shadow-inner'
                                                : 'text-white'
                                            }`} style={{
                                                background: selectedValue === 'No' ? '#D97706' : '#E87C21',
                                                borderRight: "1px solid #fff"
                                            }}>No
                                        </div>
                                        <div className={`flex-1 text-center py-[11px] text-[14px] transition-all duration-150 ${selectedValue === 'Not sure'
                                                ? 'text-white font-bold shadow-inner'
                                                : 'text-white'
                                            }`} style={{
                                                background: selectedValue === 'Not sure' ? '#D97706' : '#E87C21'
                                            }}>Not sure
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default PeerFeedbackPage;

